import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/shared/components/Button/index.js